<template>
  <div>
    <button class="button button-blue button-width-auto" type="button" @click="actionPublish">
        {{ locolize.CMS_PUSH_CRISIS_SEND_BUTTON }}
    </button>

    <modal
        v-if="submitOpen"
        :title="locolize.CMS_PUSH_CRISIS_SUBMIT_POPUP_TITLE"
        :message="locolize.CMS_PUSH_CRISIS_SUBMIT_POPUP_DESCRIPTION"
        :cancelShow="true"
        :confirmLabel="locolize.CMS_PUSH_CRISIS_CONFIRM_BUTTON"
        @cancel="submitCancel"
        @confirm="submitConfirm"
    />
</div>

</template>
<script>
import Modal from '@/components/Modal.vue';
import { TYPE_TARGET_COUNTRIES, TRAVELSTATUS_TRAVELLING } from '@/pages/notifications/NotificationsForm.vue';
import { locolize } from '@/i18n/index';

export default {
    name: 'send-crisis-notification-button',
    components: {
        Modal,
    },
    props: {
        countryId: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            submitOpen: false,
            regioncodes: [],
        };
    },
    computed: {
        locolize: () => locolize['en-GB'],
        submitData() {
            return {
                notificationType: TYPE_TARGET_COUNTRIES,
                countryIds: [{ id: this.countryId }],
                travelstatuses: [TRAVELSTATUS_TRAVELLING],
                locales: {
                    de: {
                        title: locolize['de-CH'].CMS_PUSH_CRISIS_TITLE,
                        url: locolize['de-CH'].CMS_PUSH_CRISIS_URL,
                        description: locolize['de-CH'].CMS_PUSH_CRISIS_TEXT,
                        urlText: locolize['de-CH'].CMS_PUSH_CRISIS_URL_TEXT,
                    },
                    it: {
                        title: locolize['it-CH'].CMS_PUSH_CRISIS_TITLE,
                        url: locolize['it-CH'].CMS_PUSH_CRISIS_URL,
                        description: locolize['it-CH'].CMS_PUSH_CRISIS_TEXT,
                        urlText: locolize['it-CH'].CMS_PUSH_CRISIS_URL_TEXT,
                    },
                    fr: {
                        title: locolize['fr-CH'].CMS_PUSH_CRISIS_TITLE,
                        url: locolize['fr-CH'].CMS_PUSH_CRISIS_URL,
                        description: locolize['fr-CH'].CMS_PUSH_CRISIS_TEXT,
                        urlText: locolize['fr-CH'].CMS_PUSH_CRISIS_URL_TEXT,
                    },
                    en: {
                        title: locolize['en-GB'].CMS_PUSH_CRISIS_TITLE,
                        url: locolize['en-GB'].CMS_PUSH_CRISIS_URL,
                        description: locolize['en-GB'].CMS_PUSH_CRISIS_TEXT,
                        urlText: locolize['en-GB'].CMS_PUSH_CRISIS_URL_TEXT,
                    },
                },
            };
        },
    },
    methods: {
        actionPublish() {
            this.submitOpen = true;
        },
        submitCancel() {
            this.submitOpen = false;
        },
        async submitConfirm() {
            this.submitOpen = false;
            try {
                await this.$store.dispatch('notifications/create', this.submitData);

                this.$router.push({ name: 'notifications', query: { m: 'success_create_notification' } });
            } catch (err) {
                if (process.env.NODE_ENV !== 'production') {
                    console.log(err);
                }
                this.$router.push({ name: this.$options.module, query: { m: 'error_server' } });
            }
        },
    },
};
</script>
